// ==========================================
// 1. IMAGE UPLOAD & ENGRAVING LOGIC
// ==========================================

// --- Image Preview Logic ---
const imageUpload = document.getElementById("imageUpload");
const uploadDropzone = document.querySelector(".upload-dropzone");
const uploadContent = document.querySelector(".upload-content");

if (imageUpload) {
    imageUpload.addEventListener("change", function(e) {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = function(event) {
                const existingPreview = uploadDropzone.querySelector(".upload-preview-img");
                if (existingPreview) existingPreview.remove();

                const img = document.createElement("img");
                img.src = event.target.result;
                img.classList.add("upload-preview-img");
                uploadDropzone.appendChild(img);
                
                if (uploadContent) uploadContent.style.opacity = "0";
            }
            reader.readAsDataURL(file);
        }
    });
}

// --- Engraving Logic ---
const radios = document.querySelectorAll('input[name="engraving_toggle"]');
const engravingFields = document.getElementById("engravingFields");
const engravingInput = document.getElementById("engravingInput");
const charCount = document.getElementById("charCount");
const maxCharCount = document.getElementById("maxCharCount");
const engravingLabel = document.getElementById("engravingLabel");
const embroideryNotice = document.getElementById("embroideryNotice"); 
const engravingColorInput = document.getElementById("engravingColorInput");
const engravingColorBtns = document.querySelectorAll('.engraving-color-btn')

let extraEngravingCost = 0;

radios.forEach(radio => {
    radio.addEventListener("change", () => {
        if (radio.value === "no") {
            // Hide everything, reset cost
            if (engravingFields) engravingFields.style.display = "none";
            if (embroideryNotice) embroideryNotice.style.display = "none";
            if (engravingInput) engravingInput.value = "";
            if (charCount) charCount.textContent = "0";
            
            extraEngravingCost = 0;
        } else {
            // Show everything, update cost
            if (engravingFields) engravingFields.style.display = "block";
            if (embroideryNotice) embroideryNotice.style.display = "flex"; 
            
            extraEngravingCost = parseInt(radio.dataset.price) || 0;

            if (radio.value === "name") {
                if (engravingInput) engravingInput.maxLength = 14;
                if (maxCharCount) maxCharCount.textContent = "14";
                if (engravingLabel) engravingLabel.textContent = "Nombre (Hasta 14 caracteres)";
            } else if (radio.value === "phrase") {
                if (engravingInput) engravingInput.maxLength = 50;
                if (maxCharCount) maxCharCount.textContent = "50";
                if (engravingLabel) engravingLabel.textContent = "Frase (Hasta 50 caracteres)";
            }

            // Trim text if they switch from Phrase back to Name
            if (engravingInput && engravingInput.value.length > engravingInput.maxLength) {
                engravingInput.value = engravingInput.value.substring(0, engravingInput.maxLength);
                if (charCount) charCount.textContent = engravingInput.value.length;
            }
        }
        updateVariant(); 
    });
});

if (engravingInput) {
    engravingInput.addEventListener("input", () => {
        if (charCount) charCount.textContent = engravingInput.value.length;
    });
}

// --- Text Color Selector Logic ---
const selectedEngravingColorDisplay = document.getElementById("selectedEngravingColorName");

engravingColorBtns.forEach(button => {
    button.addEventListener("click", () => {
        // Remove active class from all buttons
        engravingColorBtns.forEach(btn => btn.classList.remove("active"));
        // Add to clicked button
        button.classList.add("active");

        // Get the actual color name instead of the hex code
        const selectedColorName = button.getAttribute("data-name");
        
        // Update the hidden input so the cart gets the friendly name
        if (engravingColorInput) {
            engravingColorInput.value = selectedColorName;
        }
        
        // Update the live text on the screen for the client
        if (selectedEngravingColorDisplay) {
            selectedEngravingColorDisplay.textContent = selectedColorName;
        }
    });
});


// ==========================================
// 2. SIZE AND COLOR SELECTORS
// ==========================================
let selectedSize = null;
let selectedColor = null;

const selectedColorName = document.getElementById("selectedColorName");
const priceDisplay = document.getElementById("productPrice");

function createSelector(selector, callback) {
    const container = document.querySelector(selector);
    if (!container) return null;

    const buttons = container.querySelectorAll("button");
    let selected = container.querySelector(".active")?.dataset;

    if (selected) {
        callback(selected);
    }

    buttons.forEach(button => {
        button.addEventListener("click", (e) => {
            e.preventDefault(); 
            buttons.forEach(btn => btn.classList.remove("active"));
            button.classList.add("active");
            selected = button.dataset;
            callback(selected);
        });
    });
}

createSelector("#sizeSelector", data => {
    selectedSize = data.size;
    updateVariant();
});

createSelector("#colorSelector", data => {
    selectedColor = data.color;
    if (selectedColorName) selectedColorName.textContent = selectedColor; 
    updateVariant();
});


// ==========================================
// 3. MASTER VARIANT UPDATE (Price + Cart ID)
// ==========================================
function updateVariant() {
    if (!selectedSize || !selectedColor || !window.productData) return;

    const matchingVariant = window.productData.variants.find(variant => {
        return variant.options.includes(selectedSize) && variant.options.includes(selectedColor);
    });

    const addToCartBtn = document.getElementById('addToCartBtn');
    const addToCartText = addToCartBtn ? addToCartBtn.querySelector('span') : null;
    const variantInput = document.getElementById('selectedVariantId');

    if (matchingVariant) {
        if (variantInput) variantInput.value = matchingVariant.id;

        if (priceDisplay) {
            const storeCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) 
                ? window.Shopify.currency.active 
                : 'USD';

            const finalPriceInCents = matchingVariant.price + (extraEngravingCost * 100);

            const formattedPrice = (finalPriceInCents / 100).toLocaleString('en-US', {
                style: 'currency',
                currency: storeCurrency
            });
            priceDisplay.textContent = formattedPrice;
        }

        if (addToCartBtn && addToCartText) {
            if (matchingVariant.available) {
                addToCartBtn.disabled = false;
                addToCartText.textContent = 'Añadir al carrito';
            } else {
                addToCartBtn.disabled = true;
                addToCartText.textContent = 'Agotado (Sold Out)';
            }
        }
    } else {
        if (addToCartBtn && addToCartText) {
            addToCartBtn.disabled = true;
            addToCartText.textContent = 'No disponible (Unavailable)';
        }
    }
}

// ==========================================
// 4. AJAX CART SUBMISSION (Surcharge Logic)
// ==========================================

const NAME_FEE_VARIANT_ID = 45162388127944;
const PHRASE_FEE_VARIANT_ID = 45162388160712;

const personalizerForm = document.querySelector('.personalizer-form');

if (personalizerForm) {
    personalizerForm.addEventListener('submit', function(e) {
        e.preventDefault(); 

        const submitBtn = document.getElementById('addToCartBtn');
        const submitText = submitBtn.querySelector('span');
        
        submitBtn.disabled = true;
        submitText.textContent = 'Añadiendo...';

        const mainVariantId = document.getElementById('selectedVariantId').value;
        const imageUpload = document.getElementById('imageUpload').files[0];
        const textToEngrave = document.getElementById('engravingInput').value;
        const colorToEngrave = document.getElementById('engravingColorInput') ? document.getElementById('engravingColorInput').value : null;
        
        // --- REQUEST 1: Send Main Product + Image Upload ---
        let mainFormData = new FormData();
        mainFormData.append('id', mainVariantId);
        mainFormData.append('quantity', 1);
        
        if (textToEngrave) {
            mainFormData.append('properties[Texto Grabado]', textToEngrave);
            // Also append the chosen color if they entered text
            if (colorToEngrave) {
                mainFormData.append('properties[Color del Texto]', colorToEngrave);
            }
        }
        if (imageUpload) {
            mainFormData.append('properties[Imagen Subida]', imageUpload);
        }

        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            body: mainFormData
        })
        .then(response => {
            if (!response.ok) throw new Error('Failed to add main product');
            return response.json();
        })
        .then(() => {
            // --- REQUEST 2: Send Fee Product (If needed) ---
            let feeVariantId = null;
            
            if (extraEngravingCost === 15000) feeVariantId = NAME_FEE_VARIANT_ID;
            if (extraEngravingCost === 30000) feeVariantId = PHRASE_FEE_VARIANT_ID;

            if (feeVariantId) {
                return fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        items: [{
                            id: feeVariantId,
                            quantity: 1,
                            properties: { 'Para producto': window.productData.title }
                        }]
                    })
                }).then(res => {
                    if (!res.ok) throw new Error('Failed to add fee product');
                    return res.json();
                });
            } else {
                return Promise.resolve();
            }
        })
        .then(() => {
            window.location.href = window.Shopify.routes.root + 'cart';
        })
        .catch((error) => {
            console.error('Error adding to cart:', error);
            submitBtn.disabled = false;
            submitText.textContent = 'Error. Intenta de nuevo.';
            alert("Hubo un error al añadir al carrito. Verifica que los IDs sean de Variante y no de Producto.");
        });
    });
}

// ==========================================
// 5. LIGHTBOX MODAL LOGIC
// ==========================================
function openLightbox(imageSrc) {
    const lightbox = document.getElementById('imageLightbox');
    const lightboxImg = document.getElementById('lightboxImage');
    
    if (lightbox && lightboxImg) {
        lightboxImg.src = imageSrc;
        lightbox.style.display = 'flex';
        // Prevent background scrolling while modal is open
        document.body.style.overflow = 'hidden'; 
    }
}

function closeLightbox() {
    const lightbox = document.getElementById('imageLightbox');
    if (lightbox) {
        lightbox.style.display = 'none';
        // Restore background scrolling
        document.body.style.overflow = 'auto'; 
    }
}

// Allow closing by pressing the Escape key
document.addEventListener('keydown', function(event) {
    if (event.key === "Escape") {
        closeLightbox();
    }
});